import { useRef } from 'react'
import { randomId } from 'utils/functions/number'

export const useRandomId = () => {
  const ref = useRef(randomId())
  return ref.current
}
